import React from 'react';
import Model from '../../components/Model';

export default function Search() {
  return (
    <Model
      title={'Search Chat History'}
      src={'/video/mobile/search-chat-history.mp4'}
      para1={
        'The chat history search functionality in this app, designed for individuals with cognitive disabilities, enables users to locate particular messages or keywords that they find useful for recalling or revisiting specific parts of conversations.\n Users with Alzheimers, or other cognitive disabilities related to age and memory will be able to utilize this functionality to quickly remember or get up-to-date with previous conversations.'
      }
    />
  );
}
